import { useGeoPricingContext } from '../context/GeoPricingContext';
import { PlanPriceConfig } from '../../../types/payments';

export const useGeoPricing = () => {
    const { geoConfig, isLoading, error, refreshPricing, countryOverride } = useGeoPricingContext();

    const isInternational = geoConfig?.is_international ?? false;
    const pricing = geoConfig?.pricing;
    const currency = pricing?.currency ?? 'COP';
    const currencySymbol = pricing?.currency_symbol ?? '$';
    
    // Configuración actual del backend enviada al cargar la app
    // Asumimos que viene en window o cargamos desde otro contexto si es necesario,
    // pero por ahora podemos leer `isInternational` como proxy.
    // Opcional: Podrías hacer un endpoint GET /payments/config general si lo necesitas.

    const formatPrice = (price: number) => {
        // Si es COP no mostramos decimales, si es USD sí
        const fractionDigits = currency === 'COP' ? 0 : 2;
        return new Intl.NumberFormat(currency === 'COP' ? 'es-CO' : 'en-US', {
            style: 'currency',
            currency: currency,
            maximumFractionDigits: fractionDigits,
            minimumFractionDigits: fractionDigits
        }).format(price);
    };

    const getPlanConfig = (planId: string): PlanPriceConfig | null => {
        if (!pricing?.plans) return null;
        return pricing.plans[planId] || null;
    };

    const getPostpagoPrice = (): number => {
        return pricing?.postpago?.price_per_message ?? 0;
    };

    const getPostpagoMinRecharge = (): number => {
        return pricing?.postpago?.min_recharge ?? 0;
    };

    return {
        geoConfig,
        isLoading,
        error,
        refreshPricing,
        isInternational,
        currency,
        currencySymbol,
        pricing,
        formatPrice,
        getPlanConfig,
        getPostpagoPrice,
        getPostpagoMinRecharge,
        countryOverride
    };
};
